import React from 'react'
import styles from './expired.styles'
import injectSheet from 'react-jss'
import Container from '../components/container/container'
import Title from '../components/title/title'
import Description from '../components/description/description'
import CatCountdown from './cat-countdown.gif'
import Button from 'pobble-components/dist/button'
import { Link } from 'react-router-dom'

const Expired = ({ classes, onResend, pending }) => (
  <Container pending={pending}>
    <img
      className={classes.img}
      src={CatCountdown}
      alt="Magic link is expired"
    />
    <Title>Time’s up</Title>
    <Description>
      <p>
        This link has expired.
        <br />
        Note you can only use it once.
      </p>
      <p>
        If you have any questions contact us at{' '}
        <a href="mailto:hello@pobble.com">hello@pobble.com</a>.
      </p>
    </Description>
    <div className={classes.buttons}>
      <Button tall secondary action={onResend}>
        Send me another link
      </Button>
      <Link to="/">
        <Button tall>Go to sign in</Button>
      </Link>
    </div>
  </Container>
)

export default injectSheet(styles)(Expired)
